import React from "react";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";

const CoreButton = ({ testo, children, ...props }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const secondaryColor = useSelector((state) => state.app.secondaryColor);
  return (
    <Button
      {...props}
      style={
        ["btn-round w-1/2", "btn-round"].includes(props.className)
          ? {
              backgroundColor: `${colorPrimary}`,
              borderColor: `${colorPrimary}`,
            }
          : props.className === "btn-round secondary"
          ? { backgroundColor: `lightgrey`, borderColor: `lightgrey` }
          : props.className === "btn-round real secondary"
          ? {
              backgroundColor: `${secondaryColor}`,
              borderColor: `${secondaryColor}`,
            }
          : null
      }
    >
      {testo}
      {children}
    </Button>
  );
};

export default CoreButton;
